module.exports = __webpack_public_path__ + "com_index_10bg.jpg?7420a0491fa77555fc898feadf65d896";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_10bg.jpg
// module id = 312
// module chunks = 0